
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import StopLossModel from "@/models/stop-loss/StopLossModel";
import TradingBotStats from "@/models/TradingBotStats";
import SensitiveNumbersMixin from "@/mixins/sensitiveNumbersMixin";

@Component({
  components: {
    TooltipIcon: () => import("@/components/general/TooltipIcon.vue"),
    UpgradeSubscriptionDialog: () =>
      import(
        "@/components/subscription/upgrade-subscription-plan/UpgradeSubscriptionDialog.vue"
      ),
    StopLossChangeDialog: () => import("./StopLossChangeDialog.vue"),
  },
  mixins: [SensitiveNumbersMixin]
})
export default class StopLossField extends Vue {
  // 📦 The bot the stop-loss will be set to
  @Prop({ default: undefined })
  public botStats!: TradingBotStats;

  // 📦 The currently selected balance for the bot
  @Prop({ default: undefined })
  public balanceInUse!: number;

  // 📦 The secondary currency of the bot
  @Prop({ default: undefined })
  private balanceInUseCurrency!: string;

  // 📦 The percentage the user has defined as a stop-loss trigger
  @Prop({ default: undefined })
  private stopLoss!: StopLossModel;

  // 🚩 Flag for whether the create subscription dialog should be shown
  private showCreateSubscriptionDialog: boolean = false;

  // 🚩 Flag for whether the create subscription dialog should be shown
  private showChangeStopLossDialog: boolean = false;

  // 📦 The calculated amount the bot should be disabled below
  private get calculatedBalanceTreshold(): number {
    if (this.stopLoss && this.stopLoss.startingPortfolio) {
      if (this.stopLoss.trailing && this.stopLoss.highestPortfolio) {
        return this.stopLoss.highestPortfolio * this.stopLossPercentageValue;
      }
      return this.stopLoss.startingPortfolio * this.stopLossPercentageValue;
    }
    return this.balanceInUse * this.stopLossPercentageValue;
  }

  // 📦 The subscription plan posed the current user is on
  private get isPaidSubscriptionPlan(): boolean {
    return this.$store.getters.isSubscriptionPaid;
  }

  // 📦 Stop-loss value that will be displayed on the screen
  private get stopLossPercentageValue(): number {
    return this.stopLoss.stop;
  }

  /**
   * 🔨 Updates the current stop-loss field
   */
  private updateStopLoss(newStopLoss: StopLossModel) {
    this.stopLoss = newStopLoss;
    this.overrideTheCurrentStopLoss(newStopLoss);
  }

  /**
   * 🔨 Overrides the current stop-loss of the bot after a successful update to the API
   */
  private overrideTheCurrentStopLoss(newStopLoss: StopLossModel) {
    const bot: TradingBotStats | undefined = (this.$store.state.bots
      .allBots as TradingBotStats[]).find(
      (bot: TradingBotStats) => bot.uid === this.botStats.uid
    );
    if (bot) {
      bot.stop_loss = newStopLoss;
    }
  }
}
